import { createTheme } from "@material-ui/core/styles";

const PRIMARY_MAIN = "#6A46E5";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: PRIMARY_MAIN,
    },
  },
});
